import React, { useEffect, useState } from "react";
import PremiumTable, { CopyButton } from "../../../../Components/Others/PremiumTable";
import { useDeleteData } from "../../../../Components/Hooks/useDeleteData";
import { GetRole } from "../../../../Components/Utils/roles";
import moment from "moment";
import {
  CancelButton,
  CreateButton,
  FilterButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import { Link, useLocation } from "react-router-dom";
import SearchBar from "../../../../Components/Utils/SearchBar";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import UseGetData from "../../../../Components/Hooks/useFetchData";
import UseGetDataSearch from "../../../../Components/Hooks/useFetchDataBySearch";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import { useFormik } from "formik";
import * as yup from "yup";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import { NuDate } from "../../../../Components/Utils/Input";
import ModalContainer from "../../../../Components/Others/ModalContainer";
import MultiEditSO from "./MultiEditSO";
import { GetAccess, GetNotUseRole, CheckEditAction, CheckDeleteAction } from "../../../../Components/Utils/roles";
import useFetchMDIndex from "../../../../Components/Hooks/useFetchMDIndex";
import UseDropDown from "../../../../Components/Hooks/useDropDown";
import ViewToggle from "../../../../Components/Utils/ViewToggle";


// SalesOrder Table Row Component
const SalesOrderTableRow = ({ row, canEdit, canDelete, handleDelete, listofNumbers, selectOneFunction, pageIndex, searchQuery }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handle = async () => handleDelete("/sales-order/" + `${row.id}`, setIsModalOpen);
  return (
    <>
      <tr className="bg-white hover:bg-white/80 transition-colors align-middle">
        <td className="p-4 text-center align-middle border-t border-l border-gray-200/60 rounded-tl-xl rounded-bl-xl">
          <input type="checkbox" checked={listofNumbers.includes(row.id)} onChange={() => selectOneFunction(row.id)} className="rounded border-gray-300 text-emerald-600 focus:ring-emerald-500 h-4 w-4 cursor-pointer" />
        </td>
        <td className="p-4 align-middle border-t border-gray-200/60 font-semibold text-sm text-gray-800 whitespace-nowrap">
          <div className="flex items-center gap-1.5">
            <Link
              to={`/sales/sales-orders/view/${row.id}`}
              state={{
                data: row,
                pageIndex: pageIndex,
                searchQuery: searchQuery,
              }}
              className="hover:underline text-sm font-bold text-gray-800"
            >
              {row.prRef || "N/A"}
            </Link>
            <CopyButton text={row.prRef} />
          </div>
        </td>
        <td className="p-4 align-middle border-t border-gray-200/60 font-semibold text-sm text-gray-800 whitespace-nowrap">
          <div className="flex items-center gap-1.5">
            <Link
              to={`/sales/sales-orders/view/${row.id}`}
              state={{
                data: row,
                pageIndex: pageIndex,
                searchQuery: searchQuery,
              }}
              className="hover:underline text-sm font-bold text-gray-800"
            >
              {row.ref || "N/A"}
            </Link>
            <CopyButton text={row.ref} />
          </div>
        </td>
        {GetNotUseRole("procurement") && (
          <td className="p-4 align-middle border-t border-gray-200/60 text-xs font-semibold text-gray-600">{row.customerName || "N/A"}</td>
        )}
        <td className="p-4 align-middle border-t border-gray-200/60 text-xs font-semibold text-gray-600">{row?.purchasers?.join(", ") || "N/A"}</td>
        <td className="p-4 align-middle border-t border-gray-200/60 text-xs font-semibold text-gray-600">{row.busySoNo || "N/A"}</td>
        <td className="p-4 align-middle border-t border-gray-200/60 whitespace-nowrap">
          <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold border ${row.paymentStatus === "Paid" ? "bg-emerald-50 text-emerald-700 border-emerald-100" :
            row.paymentStatus === "Partial" ? "bg-amber-50 text-amber-700 border-amber-100" :
              "bg-gray-50 text-gray-600 border-gray-100"
            }`}>{row.paymentStatus || "N/A"}</span>
        </td>
        <td className="p-4 align-middle border-t border-gray-200/60 text-xs font-semibold text-gray-600">{row.salesPersonName || "N/A"}</td>
        <td className="p-4 align-middle border-t border-gray-200/60 whitespace-nowrap">
          <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold border ${row.status === "Approved" || row.status === "Completed" ? "bg-emerald-50 text-emerald-700 border-emerald-100" :
            row.status === "Pending" ? "bg-amber-50 text-amber-700 border-amber-100" :
              "bg-gray-50 text-gray-600 border-gray-100"
            }`}>{row.status || "N/A"}</span>
        </td>
        <td className="p-4 text-center align-middle border-t border-r border-gray-200/60 rounded-tr-xl rounded-br-xl">
          <div className="flex items-center justify-center gap-1.5">
            <Link
              to={`/sales/sales-orders/view/${row.id}`}
              state={{
                data: row,
                pageIndex: pageIndex,
                searchQuery: searchQuery,
              }}
              className="border border-blue-200 text-blue-600 hover:bg-blue-50 p-1.5 rounded-md transition-all"
              title="View"
            >
              <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" /></svg>
            </Link>
            {CheckEditAction(row, "Sales Order", canEdit) && <Link to={`/sales/sales-orders/edit/${row.id}`} state={{ data: row, from: "/sales/sales-orders", pageIndex: pageIndex, searchQuery: searchQuery }} className="border border-sky-200 text-[#0ea5e9] hover:bg-sky-50 p-1.5 rounded-md transition-all" title="Edit">
              <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-5M18.5 2.5a2.121 2.121 0 113 3L12 15l-4 1 1-4 9.5-9.5z" /></svg>
            </Link>}
            {CheckDeleteAction(row, canDelete) && <button onClick={() => setIsModalOpen(true)} className="border border-red-200 text-red-500 hover:bg-red-50 p-1.5 rounded-md transition-all" title="Delete">
              <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" /></svg>
            </button>}
          </div>
        </td>
      </tr>
      <ModalContainer
        visiable={isModalOpen}
        title="Warning"
        content={`Are you sure, ${row.ref} will be removed from Sales Orders!`}
        handleClick={() => handle()}
        closeModal={() => setIsModalOpen(false)}
      />
    </>)
}
// SalesOrder Card Wrapper Component
const SalesOrderCardWrapper = ({ row, canEdit, canDelete, handleDelete, pageIndex, searchQuery }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handle = async () => handleDelete("/sales-order/" + `${row.id}`, setIsModalOpen);
  return (
    <>
      <div className="relative border border-y-gray-200/50 border-r-gray-200/50 border-l-0 shadow-[0_4px_20px_rgba(0,0,0,0.05)] hover:shadow-[0_10px_30px_rgba(0,0,0,0.08)] transition-all duration-300 rounded-2xl bg-white p-5 flex flex-col gap-4 overflow-hidden border-l-4 border-l-cyan-500">
        <div className="flex justify-between items-start gap-4">
          <div className="flex flex-col">
            <div className="flex items-center gap-1.5">
              <Link
                to={`/sales/sales-orders/view/${row.id}`}
                state={{
                  data: row,
                  pageIndex: pageIndex,
                  searchQuery: searchQuery,
                }}
                className="text-gray-800 font-bold hover:underline text-sm"
              >
                {row.ref || "N/A"}
              </Link>
              <CopyButton text={row.ref} />
            </div>
            <div className="flex items-center gap-1 mt-0.5">
              <span className="text-[10px] text-gray-500 font-bold">YPR: {row.prRef || "N/A"}</span>
              <CopyButton text={row.prRef} />
            </div>
            {GetNotUseRole("procurement") && (
              <span className="text-[10px] text-gray-400 font-bold mt-0.5">Customer: {row.customerName || "N/A"}</span>
            )}
          </div>
          <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold border ${row.status === "Approved" || row.status === "Completed" ? "bg-emerald-50 text-emerald-700 border-emerald-100" :
            row.status === "Pending" ? "bg-amber-50 text-amber-700 border-amber-100" :
              "bg-gray-50 text-gray-600 border-gray-100"
            }`}>{row.status || "N/A"}</span>
        </div>
        <div className="bg-[#FAFAFC]/60 rounded-xl p-3.5 border border-gray-100 flex justify-between text-xs">
          <div className="flex flex-col gap-0.5">
            <span className="text-[10px] font-semibold text-gray-400 uppercase tracking-wider">Salesman</span>
            <span className="font-bold text-gray-700 truncate max-w-[100px]">{row.salesPersonName || "N/A"}</span>
          </div>
          <div className="flex flex-col gap-0.5">
            <span className="text-[10px] font-semibold text-gray-400 uppercase tracking-wider">Payment</span>
            <span className={`font-bold ${row.paymentStatus === "Paid" ? "text-emerald-600" : row.paymentStatus === "Partial" ? "text-amber-600" : "text-gray-700"}`}>{row.paymentStatus || "N/A"}</span>
          </div>
        </div>
        <div className="flex items-center justify-between border-t border-gray-100 pt-3 mt-1">
          <Link
            to={`/sales/sales-orders/view/${row.id}`}
            state={{
              data: row,
              pageIndex: pageIndex,
              searchQuery: searchQuery,
            }}
            className="border border-gray-200 text-gray-600 hover:bg-gray-50 px-2.5 sm:px-3.5 py-1.5 rounded-lg transition-all text-xs font-semibold flex items-center gap-1.5 whitespace-nowrap"
            title="View Details"
          >
            <svg className="w-3.5 h-3.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" /></svg>
            <span className="hidden sm:inline">View Details</span>
          </Link>
          <div className="flex items-center gap-1.5">
            {CheckEditAction(row, "Sales Order", canEdit) && (
              <Link
                to={`/sales/sales-orders/edit/${row.id}`}
                state={{ data: row, from: "/sales/sales-orders", pageIndex: pageIndex, searchQuery: searchQuery }}
                className="border border-sky-100 text-[#0ea5e9] hover:bg-sky-50 px-2.5 sm:px-3.5 py-1.5 rounded-lg transition-all duration-200 flex items-center gap-1.5 text-xs font-semibold whitespace-nowrap"
                title="Edit"
              >
                <svg className="w-3.5 h-3.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-5M18.5 2.5a2.121 2.121 0 113 3L12 15l-4 1 1-4 9.5-9.5z" />
                </svg>
                <span className="hidden sm:inline">Edit</span>
              </Link>
            )}
            {CheckDeleteAction(row, canDelete) && (
              <button
                onClick={() => setIsModalOpen(true)}
                className="border border-red-100 text-red-500 hover:bg-red-50 px-2.5 sm:px-3.5 py-1.5 rounded-lg transition-all duration-200 flex items-center gap-1.5 text-xs font-semibold whitespace-nowrap"
                title="Delete"
              >
                <svg className="w-3.5 h-3.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
                <span className="hidden sm:inline">Delete</span>
              </button>
            )}
          </div>
        </div>
      </div>
      <ModalContainer
        visiable={isModalOpen}
        title="Warning"
        content={`Are you sure, ${row.ref} will be removed from Sales Orders!`}
        handleClick={handle}
        closeModal={() => setIsModalOpen(false)}
      />
    </>
  );
};

function SalesOrdersIndex() {

  const location = useLocation();
  const currentPage = location.state?.currentPage
  const searchQuery = location.state?.searchQuery
  const [page, setPage] = useState(currentPage || 1)
  const [pageCount, setPageCount] = useState(localStorage.getItem("perPageView") || 20)

  const state = location.state;
  const [filter, setFilter] = useState(
    state?.fromDate || state?.toDate ? true : false
  );
  const [showFilterDialog, setShowFilterDialog] = useState(false);
  const { value: ApprovalStatus, getData: refApprovalStatus } =
    useFetchMDIndex(
      `/dropdown/dropdown-details/`,
      "ApprovalStatus_SalesOrder"
      , showFilterDialog);
  // const {value:CustomerDiscount ,getData:refCustomerDiscount} = useFetchMDIndex(`/dropdown/dropdown-details/`,'CustomerDiscount_SalesOrder',showFilterDialog)
  const { value: PaymentStatus, getData: refPaymentStatus } = useFetchMDIndex(
    `/dropdown/dropdown-details/`,
    "PaymentStatus_SalesOrder"
    , showFilterDialog);
  const { value: TermsAndConditions, getData: refTermsAndConditions } =
    useFetchMDIndex(
      `/dropdown/dropdown-details/`,
      "termsAndConditions_SalesOrder"
      , showFilterDialog);
  const { value: ShippingMethod, getData: refShippingMethod } =
    useFetchMDIndex(
      `/dropdown/dropdown-details/`,
      "shippingMethod_SalesOrder"
      , showFilterDialog);
  const { value: status } = useFetchMDIndex(`/dropdown/dropdown-details/`, 'Status_SalesOrder', showFilterDialog);
  const { data: RFQAssignee } = UseDropDown('/user/procurement/drop-down');
  const { data: Salesman } = UseDropDown('/user/salesman/drop-down');

  const [filterProps, setFilterProps] = useState({
    paymentStatus: "",
    status: "",
    shippingMethod: "",
    fromDate: "",
    toDate: "",
    rfqAssignee: "",
    salesPerson: "",
    approvalStatus: "",
    termsAndConditions: "",

  });
  const [params, setParams] = useState({
    page: page,
    per_page: pageCount,
    search: searchQuery || "",

    status: "",
    paymentStatus: "",
    shippingMethod: "",
    fromDate: state?.fromDate ? state.fromDate : "",
    toDate: state?.toDate ? state.toDate : "",
    rfqAssignee: "",
    salesPerson: "",
    approvalStatus: "",
    termsAndConditions: "",
  });

  const clearFilter = () => {
    setParams({
      ...params,
      division: "",
      status: "",
      paymentStatus: "",
      shippingMethod: "",
      fromDate: "",
      toDate: "",
      rfqAssignee: "",
      salesPerson: "",
      approvalStatus: "",
      termsAndConditions: "",
    });
    formik.values.status = "";
    formik.values.paymentStatus = "";
    formik.values.shippingMethod = "";
    formik.values.fromDate = "";
    formik.values.toDate = "";
    formik.values.rfqAssignee = "";
    formik.values.salesPerson = "";
    formik.values.approvalStatus = "";

    formik.values.termsAndConditions = "";

    setFilter(false);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: filterProps,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      // email: yup.string().required('Email is required!'),
    }),
    onSubmit: async (value, { resetForm }) => {
      console.log("ffff", value);
      setParams({
        ...params,
        paymentStatus: value.paymentStatus,
        shippingMethod: value.shippingMethod,
        status: value.status,
        fromDate: value.fromDate,
        toDate: value.toDate,
        rfqAssignee: value.rfqAssignee,
        salesPerson: value.salesPerson,
        approvalStatus: value.approvalStatus,

        termsAndConditions: value.termsAndConditions,
      });
      closeFilterDialog();
      setFilter(true);
      setFilterProps({
        paymentStatus: "",
        status: "",
        shippingMethod: "",
        fromDate: "",
        toDate: "",
        rfqAssignee: "",
        salesPerson: "",
        approvalStatus: "",
        termsAndConditions: "",
      });
    },
  });

  const { data, totalCount, getData, dataLoading } = UseGetDataSearch(
    "/sales-order/",
    params
  );
  const defaultHeader = [
    // Uncomment this section if the ID column is required.
    // {
    //   title: "ID",
    //   width: "5%",
    //   field: "id",
    //   textAlign: "center",
    //   rowAlign: "center",
    // },
    {
      title: "YPR",
      width: "10%",
      isLink: true,
      id: "id",
      link: '/sales/sales-orders/view/',
      field: "prRef",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "SO No.",
      width: "10%",
      isLink: true,
      id: "id",
      link: '/sales/sales-orders/view/',
      field: "ref",
      textAlign: "center",
      rowAlign: "center",
    },
    // Conditionally include the "Customer" column.
    ...(GetNotUseRole("procurement")
      ? [
        {
          title: "Customer",
          width: "10%",
          field: "customerName",
          textAlign: "center",
          rowAlign: "center",
        },
      ]
      : []),
    {
      title: "Purchasers",
      width: "10%",
      field: "purchasers",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Busy SO No.",
      width: "10%",
      field: "busySoNo",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Payment Status",
      width: "10%",
      field: "paymentStatus",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Salesman",
      width: "10%",
      field: "salesPersonName",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Status",
      width: "10%",
      field: "status",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Action",
      width: "5%",
      field: "action",
      textAlign: "center",
      rowAlign: "center",
      contents: {
        // Add your fetcher function here if needed.
        id: "id",
        removeValue: "ref",
        url: `/sales-order/`,
        moduleName: "Sales-Orders",
        from: `/sales/sales-orders`,
        editLink: "/sales/sales-orders/edit/",
        viewLink: "/sales/sales-orders/view/",
      },
    },
  ];

  const availableHeaders = [
    // {
    //   title: "ID",
    //   width: "5%",
    //   field: "id",
    //   textAlign: "center",
    //   rowAlign: "center",
    // },
    {
      title: "YPR",
      width: "10%",
      isLink: true,
      id: "id",
      link: '/sales/sales-orders/view/',
      field: "prRef",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "SO No.",
      width: "10%",
      isLink: true,
      id: "id",
      link: '/sales/sales-orders/view/',
      field: "ref",
      textAlign: "center",
      rowAlign: "center",
    },
    ...(GetNotUseRole("procurement")
      ? [
        {
          title: "Customer",
          width: "10%",
          field: "customerName",
          textAlign: "center",
          rowAlign: "center",
        },
      ]
      : []),
    {
      title: "Purchasers",
      width: "10%",
      field: "purchasers",
      textAlign: "center",
      rowAlign: "center",
    },
    {

      title: "Busy SO No.",
      width: "10%",
      field: "busySoNo",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Payment Status",
      width: "10%",
      field: "paymentStatus",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Salesman",
      width: "10%",
      field: "salesPersonName",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Status ",
      width: "10%",
      field: "status",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Customer Quote ",
      width: "10%",
      field: "CQRef",
      textAlign: "center",
      rowAlign: "center",
    },

    {
      title: "Customer Order ",
      width: "10%",
      field: "cusOrderRef",
      textAlign: "center",
      rowAlign: "center",
    },


    {
      title: "Received On  ",
      width: "10%",
      type: "date",
      field: "orderReceivedOn",
      textAlign: "center",
      rowAlign: "center",
    },



    {
      title: "Shipping Method",
      width: "10%",
      field: "shippingMethod",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Terms and Conditions",
      width: "10%",
      field: "termsAndConditions",
      textAlign: "center",
      rowAlign: "center",
    },
    // {
    //   title: "Sub-Total",
    //   width: "10%",
    //   field: "subTotal",
    //   textAlign: "center",
    //   rowAlign: "center",
    // },

    {
      title: "Requested Delivery",
      width: "10%",
      field: "requestedDeliveryDate",
      type: "date",
      textAlign: "center",
      rowAlign: "center",
    },

    {
      title: "Delivery Address",
      width: "10%",
      field: "deliveryAddress",
      textAlign: "center",
      rowAlign: "center",
    },
    {
      title: "Billing Address ",
      width: "10%",
      field: "billingAddress",
      textAlign: "center",
      rowAlign: "center",
    },

    // {
    //   title: "Approval By",
    //   width: "10%",
    //   field: "approvedByName",
    //   textAlign: "center",
    //   rowAlign: "center",
    // },
    // {
    //   title: "Approval Status",
    //   width: "10%",
    //   field: "approvalStatus",
    //   textAlign: "center",
    //   rowAlign: "center",
    // },
    // {
    //   title: "Requested By",
    //   width: "10%",
    //   field: "requestedByName",
    //   textAlign: "center",
    //   rowAlign: "center",
    // },


    // {
    //   title: "Shipping Instruction",
    //   width: "10%",
    //   field: "shippingInstruction",
    //   textAlign: "center",
    //   rowAlign: "center",
    // },




    {
      title: "Action",
      width: "5%",
      field: "action",
      textAlign: "center",
      rowAlign: "center",
      contents: {
        // fetcher: getData,
        id: "id",
        removeValue: "ref",
        url: `/sales-order/`,
        moduleName: "Sales-Orders",
        from: `/sales/sales-orders`,
        editLink: "/sales/sales-orders/edit/",
        viewLink: "/sales/sales-orders/view/",
      },
    },
  ];
  const [viewMode, setViewMode] = useState(localStorage.getItem("salesOrdersViewMode") || "table");

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setViewMode("card");
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const canEdit = GetAccess("sales_order_edit") || GetRole();
  const canDelete = GetAccess("sales_order_delete") || GetRole();
  const { handle: handleDelete } = useDeleteData(getData);

  useEffect(() => {
    localStorage.setItem("salesOrdersViewMode", viewMode);
    setParams({ ...params, page: page, per_page: pageCount })
  }, [page, pageCount, viewMode]);

  const closeFilterDialog = () => {
    setShowFilterDialog(false);
  };

  const [showEdit, setShowEdit] = useState(false)
  const [showDelete, setShowDelete] = useState(false)
  const [listofNumbers, setListofNumbers] = useState([])
  const [fullList, setFullList] = useState([])

  const selectOneFunction = (value) => {
    let NewId;
    if (listofNumbers && listofNumbers.some(Item => Item === value)) {
      NewId = listofNumbers.filter(Temp => Temp !== value);
      setListofNumbers(NewId)
    } else {
      setListofNumbers([...listofNumbers, value])
    }
  }

  const selectMultipleFunction = (e) => {
    console.log(e.target.checked);
    if (e.target.checked) {
      setListofNumbers(fullList)
    } else {
      setListofNumbers([])
    }

  }

  useEffect(() => {
    let tempArr = []
    data && data.forEach(i => {
      console.log("I", i?.id);
      tempArr.push(i?.id)
    });
    setFullList(tempArr)
  }, [data])


  return (
    <div className="w-full h-full px-2 sm:px-4 py-2">
      <div className="w-full flex flex-col md:flex-row justify-between items-stretch md:items-center gap-2 md:gap-3 mb-3">
        <div className="w-full md:w-auto flex justify-between items-center gap-2">
          <Breadcrumb
            items={[
              {
                name: "Sales",
              },
              {
                name: "Sales Order",
              },
            ]}
          />
          <div className="flex md:hidden items-center gap-1.5 flex-wrap">
            <FilterButton handleClick={() => setShowFilterDialog(true)} />
            {filter && (
              <FilterButton handleClick={() => clearFilter()} label="Clear" />
            )}
            {GetAccess("sales_order_create") && <Link to="/sales/sales-orders/create/">
              <CreateButton label="Sales-Order" />
            </Link>}
          </div>
        </div>

        <div className="w-full md:w-auto flex flex-wrap md:flex-nowrap items-center justify-between md:justify-start gap-2">
          <div className="w-full md:w-auto flex-1 min-w-0">
            <SearchBar
              handleChange={(e) => {
                setParams({ ...params, search: e.target.value, page: 1 });
                setPage(1)
              }}
              value={params.search}
            />
          </div>

          <div className="hidden md:flex items-center gap-2">

            <ViewToggle
              viewMode={viewMode}
              onViewChange={(mode) => setViewMode(mode)}
              storageKey="salesOrdersViewMode"
            />
            <FilterButton handleClick={() => setShowFilterDialog(true)} />
            {filter && (
              <FilterButton handleClick={() => clearFilter()} label="Clear" />
            )}
            {GetAccess("sales_order_create") && <Link to="/sales/sales-orders/create/">
              <CreateButton label="Sales-Order" />
            </Link>}
          </div>
        </div>
      </div>
      <PremiumTable
        data={data}
        total={totalCount}
        pageIndex={page}
        setPageIndex={setPage}
        dataCount={pageCount}
        setDataCount={setPageCount}
        viewMode={viewMode}
        headers={[
          { title: "YPR", width: "150px" },
          { title: "SO No.", width: "150px" },
          ...(GetNotUseRole("procurement") ? [{ title: "Customer", width: "auto" }] : []),
          { title: "Purchasers", width: "160px" },
          { title: "Busy SO No.", width: "140px" },
          { title: "Payment Status", width: "140px" },
          { title: "Salesman", width: "150px" },
          { title: "Status", width: "120px" },
          { title: "Action", align: "center", width: "120px" }
        ]}
        renderRow={(row, idx) => (
          <SalesOrderTableRow
            row={row}
            canEdit={canEdit}
            canDelete={canDelete}
            handleDelete={handleDelete}
            listofNumbers={listofNumbers}
            selectOneFunction={selectOneFunction}
            pageIndex={page}
            searchQuery={params?.search || ""}
          />
        )}
        renderCard={(row, idx) => (
          <SalesOrderCardWrapper
            row={row}
            canEdit={canEdit}
            canDelete={canDelete}
            handleDelete={handleDelete}
            pageIndex={page}
            searchQuery={params?.search || ""}
          />
        )}
        dataLoading={dataLoading}
        listofNumbers={listofNumbers}
        selectMultipleFunction={selectMultipleFunction}
        fullList={fullList}
        showEdit={showEdit}
        setShowEdit={setShowEdit}
      />
      {showFilterDialog && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center p-2">
          <div className="animate-scale-in w-[95%] sm:w-[500px] max-w-[95vw] max-h-[85vh] bg-white py-4 px-4 sm:px-6 rounded-lg shadow-xl overflow-y-auto">
            <h2 className="text-lg font-semibold mb-4">Filter Sales Orders</h2>
            <form onSubmit={formik.handleSubmit}>
              <div className="flex flex-col mb-4">
                <p className="py-1 text-sm font-medium">Date Range</p>
                <div className="flex flex-col sm:flex-row justify-between gap-2 w-full">
                  <NuDate
                    label="From "
                    placeholder="dd/mm/yyyy"
                    formik={formik}
                    name="fromDate"
                    width="w-full "
                  />
                  <NuDate
                    label="To "
                    placeholder="dd/mm/yyyy"
                    formik={formik}
                    name="toDate"
                    width="w-full "
                  />
                </div>
                <FormikSelectTwo
                  label="Payment Status"
                  placeholder="Choose"
                  formik={formik}
                  Options={PaymentStatus}
                  name="paymentStatus"
                  width="w-full "
                />
                <FormikSelectTwo
                  // type="text"
                  label="RFQ Assignee"
                  placeholder="RFQ Assignee"
                  Options={RFQAssignee}
                  formik={formik}
                  name="rfqAssignee"
                  width="w-full "
                />
                <FormikSelectTwo
                  type="text"
                  label="Sales Person"
                  placeholder="Choose"
                  Options={Salesman}
                  formik={formik}
                  name="salesPerson"
                  width="w-full"
                />

                <FormikSelectTwo
                  type="text"
                  label="Shipping Method"
                  placeholder="Choose"
                  Options={ShippingMethod}
                  formik={formik}
                  name="shippingMethod"
                  width="w-full"
                />
                <FormikSelectTwo
                  type="text"
                  label="Terms And Conditions"
                  placeholder="Choose"
                  Options={TermsAndConditions}
                  formik={formik}
                  name="termsAndConditions"
                  width="w-full"
                />
                <FormikSelectTwo
                  type="text"
                  label="Status"
                  placeholder="Choose"
                  Options={status}
                  formik={formik}
                  name="status"
                  width="w-full "
                />
                {/* <FormikSelectTwo
              type="text"
              label="Approval Status"
              placeholder="Approval Status"
              Options={[
                {
                  value: "Pending",
                  label: "Pending",
                },
                {
                  value: "Verified",
                  label: "Verified",
                },
                {
                  value: "Approved",
                  label: "Approved",
                },
                                         

              ]}
              formik={formik}
              name="approvalStatus"
              width="w-full "
            /> */}
              </div>
              <div className="flex justify-end gap-2">
                <CancelButton handleClick={closeFilterDialog} />
                <SubmitButton name="Apply" />
              </div>
            </form>
          </div>
        </div>
      )}
      {showEdit && (<MultiEditSO data={listofNumbers} getData={getData} onClose={() => setShowEdit(false)} />)}
      <ModalContainer
        visiable={showDelete}
        title="Warning"
        content={`Are you sure, All selected datas will be removed from YPR List!`}
        handleClick={() => { }}
        closeModal={() => setShowDelete(false)}
      />
    </div>
  );
}
export default SalesOrdersIndex;
